import http, { url } from '../../http'

const API_URL = "employee"

class employeeByIDAPI {

  async getId(id) {
    const response = await http(`${API_URL}/list/${id}`)
    return response
  }
   
} 

export default new employeeByIDAPI()